
//import {showAttachments} from "./SendMail.js";


export class MailFormClient {
	/**
	 * @param {string} mailIdent - ID od opened mailForm window with this socket
	 */
	constructor(mailIdent) {
		this.mailIdent = mailIdent;
		/**
		 * @type {WebSocket}
		 */
		this.socket = null;
		this.connect();
	}

	connect() {
		let url = new URL('mailForm/'+this.mailIdent, window.location.href);
		url.protocol = url.protocol.replace('http', 'ws');
		this.socket = new WebSocket(url.href);
		this.socket.addEventListener("open", this.socketOpen.bind(this));
		this.socket.addEventListener("close", this.socketClose.bind(this));
		this.socket.addEventListener("message", this.socketMessage.bind(this));
		this.socket.addEventListener("error", this.socketError.bind(this));
	}

	socketOpen() {
	}

	socketClose(evt) {
	}

	socketError(event) {
		//console.error("WebSocket error observed:", event);
	}

	socketMessage(event) {
		const data = JSON.parse(event.data);
		const eventId = data.id;

		switch (data.type) {	// See Java type ChatEvent.Type
			case "showAttachment":
				$('#refreshAttachments').change();
				break;
			default:
				console.log("Unsupported socket event " + data.type);
		}
	}

	sendMessage(msg) {
		if (this.socket.readyState === WebSocket.OPEN) {
			this.socket.send(JSON.stringify(msg));
		}
		else {
			console.log("Cannot send message to the server - socket not ready [" + this.socket.readyState + "]");
		}
	}
}
